// extracted by mini-css-extract-plugin
export const FloatButton = "floatButton-module--FloatButton--3j4-T";
export const numberindicator = "floatButton-module--numberindicator--Tjjjw";
export const FloatCard = "floatButton-module--FloatCard--19RF5";
export const FloatCardInnerContainer = "floatButton-module--FloatCardInnerContainer--eLVXz";
export const FloatCardInner = "floatButton-module--FloatCardInner--2KjIk";